import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
import close from "Assets/images/cross_icon.png"
// css
import styles from "./ReportModal.module.scss";

import CommonButton from "components/Common/CommonButton";
import { successMessageToast } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useResendClientReportMutation } from "store/services/report";
import { usePublishDocumentMutation } from "store/services/clients/attachment";
import { useParams } from "react-router-dom";
import { NoRecordFound, NoRecordFoundV2 } from "components/Common/Common";

const ReportSendModal = ({ show, setShow, data, reportId, guardians }) => {
    const [selectedItems, setSelectedItems] = useState([])
    const [password, setPassword] = useState("")
    const guardianData = guardians?.map((item) => ({
        firstname: item?.client_guardian?.firstname,
        lastname: item?.client_guardian?.lastname,
        email: item?.client_guardian?.email,
        id: item?.client_guardian?.id,
        role: item?.client_guardian?.client_role?.slug,
    }))
    const [resendClientReport, { isLoading }] = useResendClientReportMutation()

    const handlePopup = () => setShow(false)


    useEffect(() => {
        if (show && data?.length) {
            setSelectedItems(data);
        }
    }, [show, data]);


    const onReportChange = (item) => {
        setSelectedItems((prev) => {
            const exists = prev.find((i) => i.email === item.email);
            if (exists) {
                return prev.filter((i) => i.email !== item.email);
            } else {
                return [...prev, item];
            }
        });
    };

    const handleSend = async () => {
        let payload = {
            emailFormData: {
                recipientList: selectedItems,
                pdfPassword: password
            },
        };


        try {
            const resp = await resendClientReport({
                data: payload,
                id: reportId,
            }).unwrap()
            console.log("resp", resp);
            if (resp.status === "success") {
                setShow(false)
                setPassword("")
                setSelectedItems([])
                successMessageToast("Email sent successfully")
            }

        } catch (error) {
            console.error(error);

        }
    };

    const isDisabled = !!selectedItems?.length && !!password.length

    return (
        <>
            {
                isLoading && <LoadingOverlay />
            }
            <Modal
                show={show}
                className={`${styles.AddNewGoalPop} modal-v2  AddNewGoalPop`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div className="reports-v2">
                        <div className="section-title d-flex align-items-center justify-content-end border-bottom-0 m-0" style={{ borderColor: "#315D99" }}>
                            <img onClick={handlePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                        </div>
                        <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                            <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99", padding: 0 }}>{"EMAIL TO"}</h6>
                        </div>
                        {
                            guardianData?.length ? <>
                                <div className="d-flex flex-column gap-3">
                                    {
                                        guardianData?.map((item, index) => {
                                            const isChecked = selectedItems.some(
                                                (i) => i.email === item.email
                                            );
                                            return (
                                                index < 2 &&
                                                <div className="d-flex flex-column gap-3">
                                                    <div className="d-flex align-items-start gap-2">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check"
                                                            checked={isChecked}
                                                            onChange={() => onReportChange(item)}
                                                            style={{ accentColor: "#b46c9f", height: 20, width: 20, }} />
                                                        <div style={{ fontSize: "14px", color: "#000", lineHeight: "1.4" }}>
                                                            <strong className="text-capitalize" style={{ color: "#000" }}>{item?.role}:</strong>
                                                            <p className="mb-0">{item?.firstname} {item?.lastname}</p>
                                                            <p className="mb-0">{item?.email}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                <div className="d-flex flex-column gap-3">
                                    <div
                                        className="proxima-regular"
                                        style={{
                                            marginTop: "15px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            maxWidth: "400px",
                                        }}
                                    >
                                        <h6 className="mb-0 border-bottom-0" style={{ color: "#174c9b", padding: 0, fontSize: "13px" }}>
                                            Password
                                        </h6>

                                        <input value={password} onChange={(e) => setPassword(e.target.value)} type="text" style={{ width: "100%", padding: "8px", border: "1px solid #ccc", fontFamily: "Proxima Nova", }} />
                                    </div>

                                    <div className="d-flex gap-2 justify-content-end">
                                        <CommonButton disabled={!isDisabled || isLoading} text="Send" onClick={handleSend} style={{ padding: "10px 20px", border: "none", outline: "none", backgroundColor: "#0d3e7d", color: "#fff", cursor: !isDisabled ? "not-allowed" : "pointer" }} />
                                    </div>
                                </div>
                            </> : <NoRecordFoundV2 message="No guardians found to send the report." />
                        }
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default ReportSendModal;